
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen w-full">
      <Navbar />
      <div className="flex-grow flex items-center justify-center bg-gray-50 dark:bg-background py-16">
        <div className="text-center max-w-lg px-4">
          <h1 className="text-5xl font-bold text-primary mb-4 dark:text-primary">404</h1>
          <p className="text-xl text-gray-700 dark:text-gray-300 mb-6">Oops! Page not found</p>
          <p className="text-gray-500 dark:text-gray-400 mb-8">
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>
          <Button asChild>
            <Link to="/">Return to Home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
